import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67be43c2")

_pushScopeId("data-v-67be43c2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("일반 진료 신청 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, " 선호하는 의사 및 희망 일/시 선택을 통해 진료를 신청합니다.", -1)
const _hoisted_3 = { class: "form__input" }
const _hoisted_4 = { class: "input__purpose" }
const _hoisted_5 = { class: "input__purpose-other" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "purpose",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode("주증상 입력"),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, " (필수)")
], -1)
const _hoisted_7 = { class: "input__files" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "purpose",
  class: "-medium"
}, "파일 첨부", -1)
const _hoisted_9 = {
  key: 0,
  class: "request__footer"
}
const _hoisted_10 = { class: "footer__doctor" }
const _hoisted_11 = { class: "label -medium" }
const _hoisted_12 = { class: "value -bold" }
const _hoisted_13 = { class: "footer__datetiem" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "label -medium" }, "희망 일/시 선택", -1)
const _hoisted_15 = { class: "value -bold" }
const _hoisted_16 = { class: "request-form__footer--actions" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("이전")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("다음")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("접수하기")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_RequestConfirm = _resolveComponent("RequestConfirm")
  const _component_RequestStep = _resolveComponent("RequestStep")
  const _component_Doctors = _resolveComponent("Doctors")
  const _component_DoctorItemOptions = _resolveComponent("DoctorItemOptions")
  const _component_DoctorScheduled = _resolveComponent("DoctorScheduled")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_FileList = _resolveComponent("FileList")
  const _component_FileUploader = _resolveComponent("FileUploader")
  const _component_FileViewer = _resolveComponent("FileViewer")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Button = _resolveComponent("Button")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _component_Form = _resolveComponent("Form")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock(_component_Form, {
        key: 0,
        class: "online-care__request__form",
        action: "",
        method: "",
        onSubmit: _ctx.saveConfirm
      }, {
        default: _withId(() => [
          (!!_ctx.alert.content)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                alert: _ctx.alert,
                "onUpdate:clear": _cache[1] || (_cache[1] = 
        () => {
          _ctx.alert.content = '';
        }
      )
              }, null, 8, ["alert"]))
            : _createCommentVNode("", true),
          (_ctx.state.isContent)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_CustomConfirmDialog, { group: "save" }),
                _createVNode(_component_RequestConfirm, {
                  ref: "confirm$",
                  accept: _ctx.goBack
                }, null, 8, ["accept"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_PageFrame, {
            modelValue: _ctx.state.page,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.page = $event)),
            class: "form__content"
          }, _createSlots({
            title: _withId(() => [
              _hoisted_1
            ]),
            subtitle: _withId(() => [
              _hoisted_2,
              _createVNode(_component_RequestStep, {
                kind: _ctx.RequestKindTypes.OnlineCare,
                step: _ctx.state.page.valueOf()
              }, null, 8, ["kind", "step"])
            ]),
            _: 2
          }, [
            (_ctx.state.isContent)
              ? {
                  name: "content",
                  fn: _withId(() => [
                    _createVNode("div", _hoisted_3, [
                      (_ctx.state.page === _ctx.PageStates.DOCTOR)
                        ? (_openBlock(), _createBlock(_component_Doctors, {
                            key: 0,
                            pDoctors: _ctx.doctors,
                            "onUpdate:pDoctors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.doctors = $event)),
                            onSelectedDoctor: _ctx.onSelectedDoctor,
                            required: true,
                            isEditable: _ctx.isEditable,
                            possibleTypes: _ctx.PossibleTypes.ONLINE_CARE,
                            doctorKey: _ctx.state.purpose.doctorKey?.valueOf(),
                            ref: "doctors$"
                          }, null, 8, ["pDoctors", "onSelectedDoctor", "isEditable", "possibleTypes", "doctorKey"]))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            (!!_ctx.selectedDoctor)
                              ? (_openBlock(), _createBlock(_component_DoctorItemOptions, {
                                  key: 0,
                                  doctor: _ctx.selectedDoctor,
                                  isProfile: true
                                }, null, 8, ["doctor"]))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (_ctx.state.page === _ctx.PageStates.SCHEDULE)
                        ? (_openBlock(), _createBlock(_component_DoctorScheduled, {
                            key: 2,
                            purpose: _ctx.state.purpose,
                            timeList: _ctx.timeList,
                            isEditable: _ctx.isEditable,
                            doctorScheduled: _ctx.doctorScheduled,
                            required: true,
                            class: "doctor-scheduled"
                          }, null, 8, ["purpose", "timeList", "isEditable", "doctorScheduled"]))
                        : _createCommentVNode("", true),
                      (_ctx.state.page === _ctx.PageStates.PURPOSE)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                            _createVNode("div", _hoisted_4, [
                              _createVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createVNode(_component_Textarea, {
                                  modelValue: _ctx.state.purpose.other,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.purpose.other = $event)),
                                  rows: 7,
                                  cols: 36,
                                  id: "purpose"
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _createVNode("div", _hoisted_7, [
                              _hoisted_8,
                              (_ctx.state.purpose.files && _ctx.state.purpose.files.length > 0)
                                ? (_openBlock(), _createBlock(_component_FileList, {
                                    key: 0,
                                    class: "upload-files",
                                    list: _ctx.state.purpose.files,
                                    onOnSelectedRow: _ctx.onSelectedRow,
                                    onDeletedFile: _ctx.deletedFile,
                                    id: _ctx.state.id,
                                    requestKind: _ctx.RequestKindTypes.OnlineCare
                                  }, null, 8, ["list", "onOnSelectedRow", "onDeletedFile", "id", "requestKind"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_FileUploader, {
                                ref: "fileUploader$",
                                isEditable: _ctx.isEditable,
                                onProgress: _ctx.filesProgress,
                                isAllowVideo: true,
                                url: _ctx.url,
                                class: "file-uploader"
                              }, null, 8, ["isEditable", "onProgress", "url"]),
                              _createVNode(_component_Sidebar, {
                                visible: _ctx.state.visibleFull,
                                "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.visibleFull = $event)),
                                baseZIndex: 1000,
                                position: "full",
                                style: {"padding":"20px"}
                              }, {
                                default: _withId(() => [
                                  (_ctx.state.selectFile)
                                    ? (_openBlock(), _createBlock(_component_FileViewer, {
                                        key: 0,
                                        select: _ctx.state.selectFile,
                                        isSidebar: false
                                      }, null, 8, ["select"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["visible"])
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                }
              : undefined,
            (_ctx.state.isContent)
              ? {
                  name: "footer",
                  fn: _withId(() => [
                    (_ctx.doctors.selectedDoctor.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.doctors.selectedDoctor[0].DeptName), 1),
                            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.doctors.selectedDoctor[0].DoctorName), 1)
                          ]),
                          _createVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createVNode("span", _hoisted_15, _toDisplayString(!!_ctx.state.purpose.date ? _ctx.selectedDate : "-") + " " + _toDisplayString(!!_ctx.state.purpose.time ? " / " + _ctx.state.purpose.time : ""), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                }
              : undefined,
            (_ctx.state.isContent)
              ? {
                  name: "action",
                  fn: _withId(() => [
                    _createVNode("div", _hoisted_16, [
                      (_ctx.state.page > 0)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "-button -medium -waikawaGrey",
                            onClick: _ctx.prev
                          }, {
                            default: _withId(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.state.page < _ctx.totalPages - 1)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "-button -medium -royalBlue",
                            onClick: _ctx.next,
                            disabled: _ctx.isValidate ? false : true
                          }, {
                            default: _withId(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.state.page === _ctx.totalPages - 1)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            class: "-button -medium -royalBlue",
                            type: "submit",
                            disabled: _ctx.isValidate ? false : true
                          }, {
                            default: _withId(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                }
              : undefined
          ]), 1032, ["modelValue"])
        ]),
        _: 1
      }, 8, ["onSubmit"]))
    : _createCommentVNode("", true)
})